import cidrRegex from 'cidr-regex';

export const EMPTY_ERR = 'Enter a CIDR range to allow or deny';
export const CIDR_FORMAT_ERR = 'Must be in CIDR format (e.g. 100.100.0.0/22)';
export const DUPLICATE_ERR = 'This CIDR is already in the list';

/**
 * Build a validator function for a CIDR IP string.  Optional parameters are used to look
 * for duplicate values that have already been saved
 *
 * @param cidrs     CIDR strings that have already been added to the list
 * @param currIndex If editing, the index of the item being edited.  That's fine to match existing CIDR.
 * @returns
 */
export function makeUniqueCIDRRequiredValidator(cidrs: string[] = [], currIndex?: number) {
  return function validateUniqueCIDR(value?: string): string | true {
    if (!value?.trim()) return EMPTY_ERR;

    if (!cidrRegex({ exact: true }).test(value)) {
      return CIDR_FORMAT_ERR;
    }

    // If the CIDR already exists, and it's not the one we're editing
    const matchingCidrIndex = cidrs.indexOf(value);
    if (matchingCidrIndex !== -1 && matchingCidrIndex !== currIndex) {
      return DUPLICATE_ERR;
    }

    return true;
  };
}
